<template>
    <form id="frm_action_point">
        <div class="text-box">
            <div class="mt-3">
                <label class="txt-right required">Mức độ rủi ro</label>
                <InputText
                    v-model="code"
                    class="input-text-box"
                    placeholder="Nhập"
                />
            </div>
            <input class="input_tmp_validator" id="code_point" />
            <div class="mt-3">
                <label class="txt-right required">Mô tả mức độ</label>
                <Textarea
                    v-model="description"
                    :autoResize="true"
                    rows="1"
                    maxlength="500"
                    class="input-text-box"
                    placeholder="Nhập"
                />
            </div>
            <input class="input_tmp_validator" id="description_point" />
            <div class="mt-3 row align-items-end">
                <div class="col-5-5">
                    <label class="txt-right required">Điểm từ</label>
                    <InputNumber
                        v-model="point_from"
                        class="input-text-box"
                        placeholder="Nhập"
                    />
                </div>
                <input class="input_tmp_validator" id="point_from" />
                <div class="col-5-5">
                    <label class="txt-right required">đến</label>
                    <InputNumber
                        v-model="point_to"
                        class="input-text-box"
                        placeholder="Nhập"
                    />
                </div>
                <input class="input_tmp_validator" id="point_to" />
                <div class="txt-right" style="flex-basis: 6.5%;" v-if="$store.getters.controllers?.formula && $store.getters.controllers?.formula.includes('edit')">
                    <label class="txt-right" style="visibility: hidden;">button</label>
                    <Button icon="pi pi-plus" class="btn-success" @click="addPoint"/>
                </div>
            </div>
            <div class="mt-3">
                <span class="txt-last-update">Lưu ý: Điểm càng cao thì mức độ rủi ro càng lớn.</span>
            </div>
        </div>
        <div class="mt-3">
            <DataTable :value="data">
                <template #empty>
                    <div class="txt-center">Chưa có dữ liệu</div>
                </template>
                <Column field="stt" header="STT" :headerStyle="{width: '7%'}">
                    <template #body="{index}">
                        {{ index + 1 }}
                    </template>
                </Column>
                <Column field="point_from" header="Điểm từ" :headerStyle="{width: '15%'}">
                    <template #body="{data}">
                        {{ data.point_from }} - {{ data.point_to }}
                    </template>
                </Column>
                <Column field="code" header="Mức độ rủi ro" :headerStyle="{width: '30%'}"></Column>
                <Column field="description" header="Mô tả mức độ" :headerStyle="{width: '35%'}"></Column>
                <Column :headerStyle="{width: '13%'}">
                    <template #body="{data, index}" v-if="$store.getters.controllers?.formula && $store.getters.controllers?.formula.includes('edit')">
                        <Button type="button" class="p-button-edit mr-2" icon="pi pi-pencil" @click="editPoint(data, index)"></Button>
                        <Button type="button" class="p-button-danger" icon="pi pi-trash" @click="removePoint(data, index)"></Button>
                    </template>
                </Column>
            </DataTable>
        </div>
        <Dialog v-if="showRmPoint" header="Xóa mức độ rủi ro" :visible.sync="showRmPoint" :containerStyle="{width: '350px'}" :modal="true">
            <div class="confirmation-content">
                <span>Bạn muốn xóa mức độ rủi ro <b>{{ objRmPoint.obj.code }}</b>?</span>
            </div>
            <template #footer v-if="$store.getters.controllers?.formula && $store.getters.controllers?.formula.includes('edit')">
                <Button type="button" label="Huỷ" icon="pi pi-times" @click="showRmPoint = false" class="p-button-danger"/>
                <Button type="button" label="Xác nhận" icon="pi pi-check" autofocus @click="acceptRmPoint" />
            </template>
        </Dialog>
        <Dialog v-if="showEditPoint" header="Sửa mức độ rủi ro" :visible.sync="showEditPoint" class="popup_matrix" :containerStyle="{width: '600px'}" :modal="true">
            <div class="confirmation-content">
                <form id="frm_action_edit_point">
                    <div class="edit-point">
                        <div class="mt-3">
                            <label class="txt-right required">Mức độ rủi ro</label>
                            <InputText
                                v-model="objEditPoint.obj.code"
                                class="input-text-box"
                                placeholder="Nhập"
                            />
                        </div>
                        <input class="input_tmp_validator" id="code_point_edit" />
                        
                        <div class="mt-3">
                            <label class="txt-right required">Mô tả mức độ</label>
                            <Textarea
                                v-model="objEditPoint.obj.description"
                                :autoResize="true"
                                rows="1"
                                maxlength="500"
                                class="input-text-box"
                                placeholder="Nhập"
                            />
                        </div>
                        <input class="input_tmp_validator" id="description_point_edit" />
                        <div class="mt-3 row align-items-end">
                            <div class="col-6">
                                <label class="txt-right required">Điểm từ</label>
                                <InputNumber
                                    v-model="objEditPoint.obj.point_from"
                                    class="input-text-box"
                                    placeholder="Nhập"
                                />
                            </div>
                            <input class="input_tmp_validator" id="point_from_point_edit" />
                            <div class="col-6">
                                <label class="txt-right required">đến</label>
                                <InputNumber
                                    v-model="objEditPoint.obj.point_to"
                                    class="input-text-box"
                                    placeholder="Nhập"
                                />
                                <input class="input_tmp_validator" id="point_to_point_edit" />
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <template #footer v-if="$store.getters.controllers?.formula && $store.getters.controllers?.formula.includes('edit')">
                <Button type="button" label="Huỷ" icon="pi pi-times" @click="cancelEditPoint" class="p-button-danger"/>
                <Button type="button" label="Xác nhận" icon="pi pi-check" autofocus @click="acceptEditPoint" />
            </template>
        </Dialog>
    </form>
</template>
  
<script>
//   import ApiRepository from "@/core/ApiRepository";
//   import moment from "moment-timezone";
export default {
    name: "pointComponent",
    props: {
      value: Array,
      show: Boolean,
      company_id:String
    },
    data() {
      return {
        point_from: null,
        point_to: null,
        code: null,
        description: null,
        data: this.$props.value,
        objRmPoint: {},
        objEditPoint: {},
        showRmPoint: false,
        showEditPoint: false
      };
    },
    watch: {
        "$props.value"() {
            this.data = [...this.$props.value];
            this.data = this.data.sort((a, b) => a.point_from - b.point_from);
        }
    },
    created() {
        this.data = this.data.sort((a, b) => a.point_from - b.point_from);
    },
    methods: {
        async validateData() {
            this.validationErrors = {};
            let code_add = document.getElementById("code_point");
            if (
                this.$commonFuction.isEmpty(this.code)
            ) {
                code_add.setCustomValidity("Mức độ rủi ro không được để trống!");
            } else {
                if (this.code.length > 255) {
                    code_add.setCustomValidity("Mức độ rủi ro nhập tối đa 255 ký tự!");
                } else {
                    code_add.setCustomValidity("");
                }
            }

            let description_add = document.getElementById("description_point");
            if (
                this.$commonFuction.isEmpty(this.description)
            ) {
                description_add.setCustomValidity("Mô tả mức độ không được để trống!");
            } else {
                if (this.description.length > 500) {
                    description_add.setCustomValidity("Mô tả mức độ nhập tối đa 500 ký tự!");
                } else {
                    description_add.setCustomValidity("");
                }
            }

            let point_from_add = document.getElementById("point_from");
            if (
                this.$commonFuction.isEmpty(this.point_from)
            ) {
                point_from_add.setCustomValidity("Điểm từ không được để trống!");
            } else {
                if (this.point_from < 0) {
                    point_from_add.setCustomValidity("Điểm từ phải là số nguyên dương!");
                } else {
                    var check_exist = this.data.filter(f => 
                        (this.point_from >= f.point_from && this.point_from <= f.point_to)
                    )
                    if (this.point_to < this.point_from) {
                        point_from_add.setCustomValidity("Điểm từ không được lớn hơn điểm đến!");
                    } else if (check_exist.length > 0) {
                        point_from_add.setCustomValidity(`Điểm từ đang thuộc khoảng ${check_exist[0].point_from} - ${check_exist[0].point_to}!`);
                    } else {
                        point_from_add.setCustomValidity("");
                    }
                }
            }

            let point_to_add = document.getElementById("point_to");
            if (
                this.$commonFuction.isEmpty(this.point_to)
            ) {
                point_to_add.setCustomValidity("Điểm đến không được để trống!");
            } else {
                if (this.point_to < 0) {
                    point_to_add.setCustomValidity("Điểm đến phải là số nguyên dương!");
                } else {
                    var check_exist_1 = this.data.filter(f => 
                        (this.point_to >= f.point_from && this.point_to <= f.point_to)
                    )
                    if (this.point_to < this.point_from) {
                        point_to_add.setCustomValidity("Điểm đến không được nhỏ hơn điểm từ!");
                    } else if (check_exist_1.length > 0) {
                        point_to_add.setCustomValidity(`Điểm đến đang thuộc khoảng ${check_exist_1[0].point_from} - ${check_exist_1[0].point_to}!`);
                    } else {
                        point_to_add.setCustomValidity("");
                    }
                }
            }

            var inpObj = document.getElementById("frm_action_point");
            if (!inpObj.checkValidity()) {
                inpObj.reportValidity();
                return true;
            }
        },
        resetData() {
            this.code = null;
            this.description = null;
            this.point_from = null;
            this.point_to = null;
        },
        async addPoint() {
            if (await this.validateData()) {
                return;
            }
            var params = {
                id: `point-${this.$commonFuction.generateUUID()}`,
                code: this.code,
                description: this.description,
                point_from: this.point_from,
                point_to: this.point_to
            };
            this.data.push(params);
            this.resetData();
            this.data = this.data.sort((a, b) => a.point_from - b.point_from);
            this.$emit("input", this.data);
        },

        async removePoint(obj, index) {
            this.objRmPoint = {
                obj: obj,
                index: index
            }
            this.showRmPoint = true;
        },
        async validateEditPoint() {
            this.validationErrors = {};
            let code_add = document.getElementById("code_point_edit");
            if (
                this.$commonFuction.isEmpty(this.objEditPoint.obj.code)
            ) {
                code_add.setCustomValidity("Mức độ rủi ro không được để trống!");
            } else {
                if (this.objEditPoint.obj.code.length > 255) {
                    code_add.setCustomValidity("Mức độ rủi ro nhập tối đa 255 ký tự!");
                } else {
                    code_add.setCustomValidity("");
                }
            }

            let description_add = document.getElementById("description_point_edit");
            if (
                this.$commonFuction.isEmpty(this.objEditPoint.obj.description)
            ) {
                description_add.setCustomValidity("Mô tả mức độ không được để trống!");
            } else {
                if (this.objEditPoint.obj.description.length > 500) {
                    description_add.setCustomValidity("Mô tả mức độ nhập tối đa 500 ký tự!");
                } else {
                    description_add.setCustomValidity("");
                }
            }

            let point_from_add = document.getElementById("point_from_point_edit");
            if (
                this.$commonFuction.isEmpty(this.objEditPoint.obj.point_from)
            ) {
                point_from_add.setCustomValidity("Điểm từ không được để trống!");
            } else {
                var check_exist = this.data.filter(f => 
                    (this.objEditPoint.obj.id != f.id && this.objEditPoint.obj.point_from >= f.point_from && this.objEditPoint.obj.point_from <= f.point_to)
                )
                if (this.objEditPoint.obj.point_to < this.objEditPoint.obj.point_from) {
                    point_from_add.setCustomValidity("Điểm từ không được nhỏ hơn điểm từ!");
                } else if (check_exist.length > 0) {
                    point_from_add.setCustomValidity(`Điểm từ đang thuộc khoảng ${check_exist[0].point_from} - ${check_exist[0].point_to}!`);
                } else {
                    point_from_add.setCustomValidity("");
                }
            }

            let point_to_add = document.getElementById("point_to_point_edit");
            if (
                this.$commonFuction.isEmpty(this.objEditPoint.obj.point_to)
            ) {
                point_to_add.setCustomValidity("Điểm đến không được để trống!");
            } else {
                var check_exist_1 = this.data.filter(f => 
                    (this.objEditPoint.obj.id != f.id && this.objEditPoint.obj.point_to >= f.point_from && this.objEditPoint.obj.point_to <= f.point_to)
                )
                if (this.objEditPoint.obj.point_to < this.objEditPoint.obj.point_from) {
                    point_to_add.setCustomValidity("Điểm đến không được nhỏ hơn điểm từ!");
                } else if (check_exist_1.length > 0) {
                    point_to_add.setCustomValidity(`Điểm đến đang thuộc khoảng ${check_exist_1[0].point_from} - ${check_exist_1[0].point_to}!`);
                } else {
                    point_to_add.setCustomValidity("");
                }
            }

            var inpObj = document.getElementById("frm_action_edit_point");
            if (!inpObj.checkValidity()) {
                inpObj.reportValidity();
                return true;
            }
        },
        async acceptRmPoint() {
            this.data.splice(this.objRmPoint.index,1);
            this.objRmPoint = {};
            this.showRmPoint = false;
            this.data = this.data.sort((a, b) => a.point_from - b.point_from);
            this.$emit("input", this.data);
        },
        async cancelEditPoint() {
            this.objEditPoint = {};
            this.showEditPoint = false;
        },
        async acceptEditPoint() {
            if (await this.validateEditPoint()) {
                return;
            }
            this.data[this.objEditPoint.index] = this.objEditPoint.obj;
            this.objEditPoint = {};
            this.showEditPoint = false;
            this.data = this.data.sort((a, b) => a.point_from - b.point_from);
            this.$emit("input", this.data);
        },
        async editPoint(obj, index) {
            var obj_tmp = Object.assign({}, obj);
            this.objEditPoint = {
                obj: obj_tmp,
                index: index
            }
            this.showEditPoint = true;
        }
    },
};
</script>

<style lang="scss">
    label {
        font-weight: bold;
    }
    .button-clear {
        position: absolute;
        background-color: red;
        border-radius: 50%;
        right: 0;
        top: 0;
        width: 20px;
        height: 20px;
        padding: 0;
        display: flex;
        cursor: pointer;
    }
    .item-img {
        width: 80px;
        height: 80px;
        position: relative;
        padding: 0;
    }
    .p-password .pi.pi-eye {
        color: #000;
        font-size: 20px;
    }
    .p-checkbox, .p-radiobutton.p-component{
        margin-right: 1rem !important;
    }
    .txt-last-update {
        color: #666666;
        font-size: calc(16px*0.8);
    }
    .ml-4-5{
        margin-left: 2.5rem !important;
    }
    .col-5-5 {
        flex: 0 0 46%;
        max-width: 46%;
        position: relative;
        width: 100%;
        padding-right: 15px;
        padding-left: 15px;
    }
    @media (max-width: 1440px) {
        .col-5-5 {
            flex: 0 0 44% !important;
            max-width: 44% !important;
        }
    }
</style>
